export default __webpack_public_path__ + "static/media/mallory_decampos.66972110.png";